import {axiosInstance} from './axiosConfig'; 
import { handleRequestWithAuth } from './refreshService';

export interface CustomUser {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    estado: boolean;
    tipo_nivel_usuario: {
        id: number;
        nombre: string;
        perfil_asociado: 'cliente' | 'personal';
        activo: boolean;
    } | null;
    telefono: string | null;
    ci_nit: string | null;
    cargo: string | null;
    perfil_asociado: 'cliente' | 'personal' | null;
    ultimo_acceso?: string;
    penultimo_acceso?: string;
    fecha_creacion?: string;
    foto_url?: string | null;
}

// Función para registrar un nuevo usuario (no requiere token).
// Sin console.log/console.error: la petición lleva la contraseña y la
// respuesta (o el AxiosError, que conserva config/request/response) puede
// reflejarla; a la consola no va ningún objeto de petición ni de respuesta.
export const registerUser = async (
    email: string,
    firstName: string,
    lastName: string,
    password: string,
    estado: boolean,
    tipo_nivel_usuario: number | null
) => {
    try {
        const response = await axiosInstance.post('register/', {
            email,
            first_name: firstName,
            last_name: lastName,
            password,
            estado,
            tipo_nivel_usuario,
        });
        return response.data;
    } catch (error: any) {
        // Intenta obtener el error de validación del email, o de detail
        const errorMessage =
            error.response?.data?.email?.[0] ||
            error.response?.data?.detail ||
            'Error de registro';
        throw new Error(errorMessage);
    }
};

export const fetchUsuarios = async (perfil?: 'cliente'): Promise<CustomUser[]> => {
    return handleRequestWithAuth(async () => {
        const response = perfil ? await axiosInstance.get<CustomUser[]>('users/operational/', {params:{perfil}}) : await axiosInstance.get<CustomUser[]>('users/operational/');
        return response.data;
    });
};

// Función para obtener todos los usuarios (requiere token)
export const getUsers = async () => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get('users/');  // Sin withCredentials
        return response.data;
    });
};

// Función para obtener un usuario por su ID (requiere token)
export const getUserById = async (userId: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`users/${userId}/`);
        return response.data;
    });
};

// Función para actualizar un usuario (requiere token)
export const updateUser = async (
    userId: number,
    firstName: string,
    lastName: string,
    email: string,
    estado: boolean,
    tipo_nivel_usuario: number | null
) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(
            `users/${userId}/`,  // URL relativa
            {
                first_name: firstName,
                last_name: lastName,
                email,
                estado,
                tipo_nivel_usuario,
            }
        );
        return response.data;
    });
};

// Función para eliminar un usuario (requiere token)
export const deleteUser = async (userId: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`users/${userId}/`);
        return response.data;
    });
};




export const fetchUsuarioById = async (id: number): Promise<CustomUser> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<CustomUser>(`users/operational/${id}/`);
        return response.data;
    });
};




export const getUser = async () => {
    try {
        const response = await axiosInstance.get('/me', {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true, // Importante para enviar la cookie httpOnly
        });
        return response.data;
    } catch (error: any) {
        throw new Error(
            error.response?.data?.detail || 'Error al obtener la información del usuario'
        );
    }
};


export const updatePerfilUsuario = async (id: number, first_name: string, last_name: string) => handleRequestWithAuth(async () => (await axiosInstance.patch(`users/${id}/`, { first_name, last_name })).data);
